import icon from './ave.png.js';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

angular
    .module('MW.InsDashboard.AveWidget', [
        'MW.Dashboard.DashboardWidgetService',
        'MW.Framework.TranslationService' ,
        'MW.InsDashboard.insightsBackendService',
        'MW.InsDashboard.ChartService',
        'DashboardChartConfigService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.CoreCommon',
        'MW.InsDashboard.InsightsDataMaps',
        'MW.InsDashboard.TransformAve',
        'MW.InsDashboard.ChartDataService',
        'CoreChartObject',
        'MW.InsDashboard.WidgetController',
        'MW.Configuration',
        'MW.Framework.CoreUserService'
    ])
    .directive('aveWidget',['DashboardWidgetService',
        'translationService' ,
        'insightsBackendService',
        'ChartService',
        '$filter',
        '$q',
        'DashboardChartConfigService',
        'InsWidgetConfigService',
        'CoreCommon',
        'InsightsDataMaps',
        'TransformAve',
        'ChartDataService',
        'CoreChartObject',
        '$controller',
        'CoreUserService',
        function(DashboardWidgetService, translationService, insightsBackendService, ChartService, $filter, $q, DashboardChartConfigService, InsWidgetConfigService, CoreCommon, InsightsDataMaps, TransformAve,ChartDataService, CoreChartObject, $controller, CoreUserService) {

        var aveWidget = DashboardWidgetService.getWidget('ave-widget');

        aveWidget.editViewFile = 'graph_widget_view';
        aveWidget.userViewFile = 'graph_widget_view';
        aveWidget.maximizedViewFile = 'graph_widget_max';
        aveWidget.reportViewFile = 'graph_widget_report';


        var aveWidgetController = function ($scope) {

            $scope.insightsService = 'statisticServiceDateReachHistogram';
            $controller('WidgetController', {$scope: $scope});//inject the scope and use the basic widget controller

        };

        var aveWidgetLink = function (scope, element) {

            var defaultAveValue = '0.37';
            var currentAveValue = defaultAveValue;

            scope.widget.settings.availableAveValue = [
                {name: 'Default Value (0.37)', id: defaultAveValue},
                {name: 'Custom Value', id: 'cv', custom: true}
            ];

            // Storing custom value
            if (scope.widget.settings.ave && scope.widget.settings.ave[0] && scope.widget.settings.ave[0].id != defaultAveValue) {
                scope.widget.settings.customValue = scope.widget.settings.ave[0].id;
                currentAveValue = scope.widget.settings.ave[0].id;
            } else if(scope.widget.settings.customValue && scope.widget.settings.ave[0].id === defaultAveValue) {
                // Deleting custom value in case of when user selected default value and save it and we dont want custom value to prefill in custome value dialog.
                delete scope.widget.settings.customValue;
            }

            var chartOverrides = {
                user: {},
                max: {}
            };

            var yAxisTitle;
            if (scope.widget.settings.currency && Array.isArray(scope.widget.settings.currency)) {
                yAxisTitle = scope.widget.settings.currency[0].id;
            } else {
                yAxisTitle = 'AVE';
            }

            var settingsOverides = {
                yAxisTitle: yAxisTitle,
                yAxisPercTitle: yAxisTitle,
                fetchDataForPreviousRange: scope.widget.settings.dateComparison
            };

            var chartConfiguration = {
                insightsService: 'statisticServiceDateReachHistogram',
                insightsObject: 'dateReachHistograms',
                AveValue: currentAveValue,
                charts: {
                    areaspline: {
                        chart: ChartService.area,
                        transform: TransformAve.areaspline,
                        dataMap: InsightsDataMaps.datamapDateVolume,
                        custom: chartOverrides,
                        customSettings: settingsOverides
                    },
                    spline: {
                        chart: ChartService.line,
                        transform: TransformAve.spline,
                        dataMap: InsightsDataMaps.datamapDateVolume,
                        custom: chartOverrides,
                        customSettings: settingsOverides
                    },
                    donut: {
                        chart: ChartService.donut,
                        transform: TransformAve.donut,
                        dataMap: InsightsDataMaps.datamapDateVolume,
                        custom: chartOverrides
                    },
                    pie: {
                        chart: ChartService.donut,
                        transform: TransformAve.donut,
                        dataMap: InsightsDataMaps.datamapDateVolume,
                        custom: chartOverrides,
                        customSettings: settingsOverides
                    },
                    column: {
                        chart: ChartService.column,
                        transform: TransformAve.column,
                        dataMap: InsightsDataMaps.datamapDateVolume,
                        custom: chartOverrides,
                        customSettings: settingsOverides
                    },
                    table: {chart: {}, transform: TransformAve.table, dataMap: InsightsDataMaps.datamapDateVolume}
                },
                table: {
                    enabled: true,
                    rowTitle: translationService.getLocalizedString('Date'),
                    summaryTitle: translationService.getLocalizedString('Total'),
                    titleField: 'name',
                    countField: 'volume',
                    percentField: 'ave',
                    drilldown: function aveTableDrilldown(datapoint) {
                        scope.internalDrillDown(datapoint.id, datapoint.date);
                    },
                    tooltip: function ave_table_tooltip(datapoint) {
                        return translationService.getLocalizedString('Volume') + ': ' + datapoint.volume + ' - ' + translationService.getLocalizedString('AVE') + ': ' + datapoint.ave;
                    },
                    customRowTitleSort: true
                }
            };

            if (scope.widget.settings && scope.widget.settings.previousDateRange && scope.widget.settings.dateComparison) {
                chartConfiguration['previousDateStart'] = moment(scope.widget.settings.previousDateRange.startDate).tz(CoreUserService.getTimezone()).format();
                chartConfiguration['previousDateEnd'] = moment(scope.widget.settings.previousDateRange.endDate).tz(CoreUserService.getTimezone()).format();
            }

            scope.initWidget(chartConfiguration);
        }
        return new WidgetDirective(aveWidget, aveWidgetLink, aveWidgetController);
    }])
    .run(['DashboardWidgetService', 'translationService', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function(DashboardWidgetService, translationService, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
        DashboardWidgetService.register({
            name: translationService.getLocalizedString('AVE'),
            app: 'ins_dashboard',
            description: translationService.getLocalizedString('The Advertising Value Equivalency (AVE) widget helps placing '+
            'a monetary value on media coverage. The widget can display up '+
            'to five separate inputs.'),
            directive: 'ave-widget',
            icon,
            defaultSettings: {
                'width': 'third',
                'title': 'Title',
                'description': '',
                source: [],
                'maxAgents': 5
            },
            displayOrder: 5,
            allowExport: true,
            requiredSettings: ['inputs'],
            availableSettings: ['dateRange', 'title', 'news','broadcast', 'rss','tags', 'chartType', 'labelFormat', 'ave', 'currency', 'dateBreakouts', 'labelVisibility', 'dateComparison'],
            availableChartTypes:[
                {name:'Line',id:'spline'},
                {name:'Bar',id:'column'},
                {name:'Area',id:'areaspline'},
                {name:'Pie',id:'pie'},
                {name:'Donut',id:'donut'}
            ],

            getDefaultChartType: function() {
                return this.availableChartTypes[1];
            },
            hasRequiredSettings: function(){
                var _widget = this;
                return InsWidgetConfigService.hasSelectedAnInput(_widget);
            },
            template,
            templateMaxView,
            templateReportView
        });

    }]);



